<template>
  <section id="header" class="header" v-bind:class="[{ 'active': menuIsActive, 'is-mobile': menuMobileIsActive }]">
    <a href="#" class="logo" v-scroll-to="'#welcome'"></a>
    <div class="nav" :class="{ 'is-mobile': menuMobileIsActive }">
      <ul class="nav-list">
        <li :class="{ 'active': activeSection == 'who-we-are'}">
          <a @click.prevent="toggleMenu()" href="#" v-scroll-to="'#who-we-are'">Quem somos</a>
        </li>
        <li :class="{ 'active': activeSection == 'what-we-do'}">
          <a @click.prevent="toggleMenu()" href="#" v-scroll-to="'#what-we-do'">O que fazemos</a>
        </li>
        <li :class="{ 'active': activeSection == 'what-we-think'}">
          <a @click.prevent="toggleMenu()" href="#" v-scroll-to="'#what-we-think'">O que pensamos</a>
        </li>
        <li :class="{ 'active': activeSection == 'contact'}">
          <a @click.prevent="toggleMenu()" href="#" v-scroll-to="'#contact'">Onde estamos</a>
        </li>
      </ul>
    </div>
    <a href="" class="hamburger" @click.prevent="toggleMenu()">
      <span></span>
      <span></span>
      <span></span>
    </a>
  </section>
</template>

<script>
export default {
  name: 'HeaderSection',
  props: ['api'],
  data() {
    return {
      msg: 'Eu sou o HeaderSection!',
      menuIsActive: false,
      menuMobileIsActive: '',
      activeSection: '',
      langs: ['pt', 'en', 'es', 'it']
    }
  },
  mounted () {
		window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
			var sections = document.getElementsByTagName('section');
			var headerHeight = document.getElementById('header').offsetHeight;
      
		
			for (var index = 0; index < sections.length; index++) {
				var sectionElement = sections[index],
						windowTop = window.scrollY,
						windowSize = windowTop + window.innerHeight,
						pageSize = document.documentElement.scrollHeight

				// Quando chegar ao fim do site: Tira o active de todos e ativa apenas o último item do menu
				if (windowSize >= pageSize) {
          this.activeSection = 'Contact'

				// Quando a janela estiver entre a seção x: Ativa o elemento de mesmo número no menu
				} else if (windowTop >= sectionElement.offsetTop - 100 && windowTop < sectionElement.offsetTop + sectionElement.offsetHeight - 100) {
          this.activeSection = sectionElement.classList[0];
				}
				//Quando o topo da tela for maior ou igual a distancia entre a seção e o início do site, menos metade do tamanho da tela:
				// if (windowTop >= sectionElement.offsetTop - window.innerHeight/2) {
				// 	if (sectionElement.className.indexOf('is-active') < 0) {
				// 		sectionElement.className += ' is-active';
				// 	}
				// }

        // Ativar a classe fixed no menu ao sair da primeira section!
        let firstSection = document.getElementsByClassName('welcome')[0].offsetHeight;
        if (windowTop + headerHeight > 0 && windowTop + headerHeight < firstSection) {
          this.menuIsActive = false;
        } else {
          this.menuIsActive = true;
        }
			}
		},
    toggleMenu () {
			this.menuMobileIsActive = !this.menuMobileIsActive;
    }
  }
}
</script>

<style scoped lang="stylus">
.header
  background $black
  padding 15px 100px
  box-sizing border-box
  position fixed
  top 0
  width 100%
  z-index 10
  display flex
  justify-content space-between
  &.active
    position fixed
    top 0
    background black
    bottom inherit
    .nav
      li
        &.lang
          span
            &:after
              transform rotate(-180deg)
          &:hover
            ul
              top 30px
            span
              &:after
                transform rotate(0)
  .hamburger
    position absolute
    right 20px
    top 30px
    display none
    z-index 2
    &:hover
      border 0 !important
      padding-bottom 0
    span
      width 30px
      height 4px
      background white
      display block
      margin 5px 0
  .logo
    display block
    background url('../assets/logo@2x.png') no-repeat center
    background-size contain
    width 300px
    display inline-block
    img
      max-width 100%
  .nav
    display inline-block
    a
      color white
      text-decoration none
      text-transform uppercase
      padding 20px 0
    li
      margin-right 20px
      display inline-block
      position relative
      &:after
        transition .3s all ease
        content ''
        width 0
        height 2px
        bottom -10px
        position absolute
        background white
        display block
      &:hover, &.active
        &:after
          width 100%
      &.lang
        border-left 1px solid white
        padding-left 20px
        position relative
        text-transform uppercase
        li
          &:after
            display none
        &:after
          display none
        &:hover
          span
            &:after
              transform rotate(180deg)
          ul
            opacity 1
            visibility visible
            top -130px
        span
          &:after
            content ''
            display inline-block
            width 11px
            transition .4s all ease
            height 7px
            margin-left 5px
            position relative
            top -2px
            background url('../assets/up-arrow.png') center no-repeat
        ul
          position absolute
          background white
          top -110px
          border 2px solid $black
          transition .4s all ease
          opacity 0
          visibility hidden
          left 0
          li
            margin 0
            display block
            padding 0 15px
            &:last-child
              a
                border 0
          a
            color $black
            border-bottom 1px solid $softGrey
            display block
            padding 10px 0
            width 100%
            margin 0 auto
            transition .3s all ease
            &:hover
              font-weight bold
@media (max-width 1085px)
  #header
    position fixed
    top 0
    bottom auto
    padding 30px 100px
    .nav
      li
        &:last-child
          a
            border 0
    &.active
      background transparent
    .hamburger
      background black
      padding 10px
      span
        transition .5s all ease
    &.is-mobile
      .hamburger
        span
          position relative
          &:nth-child(1)
            transform rotate(45deg)
            top 9px
          &:nth-child(2)
            opacity 0
          &:nth-child(3)
            transform rotate(-45deg)
            top -9px
          
    .nav
      opacity 0
      visibility hidden
      background $black
      width 100%
      margin 0
      position fixed
      top 0
      left 0
      background rgba(32,35,40, .99)
      height 100%
      transform none
      transition 250ms all ease
      &.is-mobile
        opacity 1
        visibility visible
        z-index 2
      .nav-list
          position absolute
          left 50%
          top 50%
          width 100%
          max-width 400px
          transform translate(-50%, -50%)
        li
          display block
          margin-right 0
          &.active
            &:after
              display none
          &.lang
            padding-left 0
            border 0
            span
              &:after
                transform rotate(180deg)
            &:hover
              span
                &:after
                  transform rotate(0)
            li
              display inline-block
              padding 20px
              a
                border 0
                padding 0
                color white
            ul
              top 56px
              width 100%
              position absolute
              border 1px solid white
              background transparent
          &:hover
            &:after
              display none
          a
            display block
            text-transform uppercase
            font-weight bold
            border-bottom 1px solid #E9E9E9
            padding 20px
    .hamburger
      display block
</style>



// WEBPACK FOOTER //
// src/components/HeaderSection.vue